import {CSS_PATH} from "./constants";
import {error} from "./log";

export function loadCSS() {

    // Check if the CSS is already loaded (the website owner might load it directly, or we get called after a bfcache restore)
    for (const l of (document.querySelectorAll('link[rel="stylesheet"]') as NodeListOf<HTMLLinkElement>)) {
        if (l.href.includes(CSS_PATH)) {
            return;
        }
    }

    // If not, load the CSS dynamically
    const head = document.head;
    const link = document.createElement("link");

    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = CSS_PATH;
    link.onerror = () => error("Failed to load SaaS Web Spam Shield CSS. Possibly blocked by Content Security Policy.");
    head.appendChild(link);
}
